import React from 'react';
import './LogoClub.css';


function LogoClub({style, club, width, height, activateLink = true}) {

    const handleOnClick = (e, url) => {
        e.preventDefault();
        if (url !== '' && url !== null && activateLink) {
            window.open(url, '_blank');
        }
    }
    return ( 
        <div className={!activateLink ? "logo_club_component" : "logo_club_component lhover"} style={{maxWidth: width, maxHeight: height, ...style}}>
            {club &&
                <img 
                    src={process.env.PUBLIC_URL + "/images/clubs/" + club.photo} 
                    width={width} 
                    height={height} 
                    title={club.title}
                    alt=""
                    style={{cursor: activateLink ? "pointer" : "default"}} 
                    onClick={(e)=>handleOnClick(e, club.url)}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; 
                        currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                    }}
                />
            }
        </div>
    );
}

export default LogoClub;